import { Icon, IconName, Pressable, Text, TextVariant } from '@rbilabs/universal-components';
import Clipboard from '@react-native-clipboard/clipboard';

import { toaster } from 'components/toaster/toaster';

export const CopyButton = (props: {
  label: string;
  textToCopy: string;
  variant?: TextVariant;
  iconName?: IconName;
}) => {
  return (
    <Pressable
      onPress={() => {
        toaster.neutral('Copied to clipboard');
        Clipboard.setString(props.textToCopy);
      }}
      flexDirection="row"
      alignItems="center"
    >
      <Text variant={props.variant} marginTop="$2" marginBottom="$2">
        {props.label}
      </Text>
      {props.iconName ? <Icon name={props.iconName} size="xs" marginLeft="$2" /> : null}
    </Pressable>
  );
};
